import { Rol } from './rol.model';

export class User {
    user_id: number;
    firstname: string;
    lastname: string;
    email: string;
    password: string;
    rol: Rol;

  /**
   * Constructor
   *
   * @param user
   */
  constructor(user) {
    this.user_id    = user.user_id   || 0;
    this.firstname  = user.firstname || '';
    this.lastname   = user.lastname  || '';
    this.email      = user.email     || '';
    this.password   = user.password  || '';
    this.rol        = user.rol       || null;
  }
}